import type { Requirement } from "@/types";

export const UNSPECIFIED_OWNER = "__unspecified_owner__";

export function ownerFilterValue(owner?: string | null): string {
  const value = (owner || "").trim();
  return value && value !== "-" ? value : UNSPECIFIED_OWNER;
}

export function ownerFilterOptions(requirements: Requirement[]): string[] {
  const owners = new Set<string>();
  for (const requirement of requirements) {
    owners.add(ownerFilterValue(requirement.owner));
  }
  return Array.from(owners).sort((a, b) => {
    if (a === UNSPECIFIED_OWNER) return -1;
    if (b === UNSPECIFIED_OWNER) return 1;
    return a.localeCompare(b);
  });
}

export function ownerFilterLabel(value: string): string {
  return value === UNSPECIFIED_OWNER ? "Unspecified" : value;
}
